import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { updateHeaderTitle } from 'apps/auth/actions/messageAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import Form from 'apps/auth/components/form-multi/Form';
import AgreePopup from 'apps/auth/components/sharedComponents/popups/AgreePopup';
import {
    TERMS_AND_AGREEMENT_ACCEPT_CLICKED,
    TERMS_AND_AGREEMENT_CONFIRMATION_SCREEN_SHOWN,
    TERMS_AND_AGREEMENT_CONTINUE_CLICKED,
    TERMS_AND_AGREEMENT_SCREEN_SHOWN,
} from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { TOS_TYPE } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { CA_TOS, US_ESING, US_TOS } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { CANADA, USA } from 'apps/auth/constants/WellKnownCountries';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

import { FILL_PROFILE_SCREEN } from './constants';

const Disclaimer = (props) => {
    const { phoneCountryId, showPopup } = useExtra();
    const {
        popupTextUsaTerms,
        popupTextUsaElectronic,
        popupTextCanadaTermsAgreement,
        disclaimerTitle,
        disclaimerText,
        disclaimerButtonAgree,
        headerTitleForFillProfile,
        headerTitle,
        consentButton,
        popupAgree,
    } = usePageMessages();
    const [agreeCounter, setAgreeCounter] = useState(1);
    const submitRef = useRef(null);
    const isUSA = phoneCountryId === USA;
    const isCanada = phoneCountryId === CANADA;

    useEffect(() => {
        sendEvent(TERMS_AND_AGREEMENT_SCREEN_SHOWN);
        props.updateHeaderTitle(disclaimerTitle);
    }, [disclaimerTitle]);

    const sendEvent = useCallback(
        (eventName, eventParam) => {
            if (isUSA || isCanada) {
                const defaultParam = isUSA ? US_TOS : CA_TOS;
                amplitude.getInstance().logEvent(eventName, { [TOS_TYPE]: eventParam || defaultParam });
            }
        },
        [isUSA, isCanada],
    );

    const usaAgreeClick = (e, agreeCounter) => {
        sendEvent(TERMS_AND_AGREEMENT_ACCEPT_CLICKED, agreeCounter === 1 ? US_ESING : undefined);
        const newAgreeCounter = agreeCounter + 1;
        setAgreeCounter(newAgreeCounter);
        disclaimerAgreeClick(e, newAgreeCounter);
    };

    const disclaimerAgreeClick = (e, agreeCounter) => {
        e.preventDefault();
        if (showPopup) {
            if (isUSA) {
                if (agreeCounter === 1 || agreeCounter === 2) {
                    sendEvent(TERMS_AND_AGREEMENT_CONFIRMATION_SCREEN_SHOWN, agreeCounter === 1 ? US_ESING : undefined);
                    props.popupRef.current?.open(
                        <AgreePopup
                            agreeHandler={(e) => usaAgreeClick(e, agreeCounter)}
                            text={agreeCounter === 1 ? popupTextUsaElectronic : popupTextUsaTerms}
                            popupRef={props.popupRef}
                            agreeButton={popupAgree}
                        />,
                    );
                } else {
                    props.popupRef.current?.close();
                    submitRef.current.click();
                }
            } else if (isCanada) {
                sendEvent(TERMS_AND_AGREEMENT_CONFIRMATION_SCREEN_SHOWN);
                props.popupRef.current?.open(
                    <AgreePopup
                        agreeHandler={() => {
                            sendEvent(TERMS_AND_AGREEMENT_ACCEPT_CLICKED);
                            props.popupRef.current?.close();
                            submitRef.current.click();
                        }}
                        text={popupTextCanadaTermsAgreement}
                        popupRef={props.popupRef}
                        agreeButton={consentButton}
                    />,
                );
            }
        } else {
            closeDisclaimer();
            props.setScreen(FILL_PROFILE_SCREEN);
        }
    };

    const closeDisclaimer = () => {
        props.updateHeaderTitle(headerTitleForFillProfile);
    };

    return (
        <>
            <HeaderPanel title={headerTitle} />
            <DangerouslyHtml dangerouslyHtml={disclaimerText} />
            <Form
                formName={props.formName}
                onSubmitHandler={props.onSubmitHandler}
                getCanonicalPath={props.getCanonicalPath}
                checkNotVisibleField={false}
                dataTestId="disclaimer-div-float-button"
            >
                <FixedBottomPanel isRightAligned>
                    <Button
                        type="button"
                        raised={true}
                        onClick={(e) => {
                            sendEvent(TERMS_AND_AGREEMENT_CONTINUE_CLICKED);
                            disclaimerAgreeClick(e, agreeCounter);
                        }}
                        caption={disclaimerButtonAgree}
                        dataTestId="disclaimer-button-agree"
                    />
                </FixedBottomPanel>
                <Button type="submit" variant={'hidden'} ref={submitRef} />
            </Form>
        </>
    );
};

export default connect(null, { updateHeaderTitle })(Disclaimer);
